import React from "react";
import { PillGroup, Pill } from "./Pill";
import { DAY_PRESETS } from "../broadcastEnums";

/**
 * The date-range picker for the Broadcasts list.
 *
 * Deliberately NOT `src/common/comms/DateRangePreset.jsx`: that control emits
 * a wire-shaped object (`{ days, date_from, date_to }`) and is shared with the
 * Coaches pages. Broadcasts filters by a day count and lets the service build
 * the window, so this one emits the bare number and nothing else.
 *
 * The presets carry no counts. A count here would have to mean "broadcasts in
 * the last N days", which is a number nobody has computed — see
 * `BroadcastFilters` for the same reasoning on the status chips.
 */

/**
 * Renders `DAY_PRESETS` as a single-select radio group.
 *
 * @param {Object} props
 * @param {number} props.days - Currently selected preset, in days (7 | 30 | 90).
 * @param {(days: number) => void} [props.onChange] - Called with the NUMERIC preset id, never a string.
 * @param {string} [props.className] - Extra classes on the group, merged last.
 * @returns {React.ReactElement}
 */
export const DateRangePills = ({ days, onChange, className = "" }) => (
  <PillGroup label="Date range" className={className}>
    {DAY_PRESETS.map((preset) => (
      <Pill
        key={preset.id}
        selected={preset.id === days}
        onSelect={() => onChange?.(preset.id)}
      >
        {preset.label}
      </Pill>
    ))}
  </PillGroup>
);

export default DateRangePills;
